import {fabric} from "fabric";
import {add_zoom_canvas} from "./Tools/zoomSceneTool";
import {add_dragging} from "./Tools/draggingSceneTool";
import store from "../store";
import {planeDrawingTool} from "./Tools/planeDrawingTool";
import {planeTool} from "./Tools/planeTool";
import {homography} from "./libs/homography";
import {addImg} from "./libs/addImg";
import {SetPerspectiveTool} from "./Tools/setPerspectiveTool";
import {additionalElementsTool} from "./Tools/additionalElementsTool";
import {platbandDrawingTool} from "./Tools/platbandDrawingTool";
import {sortObjectsByZindex} from "./libs/sortObjectsByZindex";
import {SetScaleTool} from "./Tools/setScaleTool";
import router from '../router/index';
import {planePolygonForTools} from "./primitives/planePolygon";
import {planeGroupingTool} from "./Tools/planeGroupingTool";
import {getScale} from "./libs/common";
import {getAdditionalPolygonPoints} from "./primitives/additionalPlane";
import {bus} from "../vue_bus";

const fabricEditor = function (canvas, options) {
    this.options = Object.assign({
        zoom: true,
        dragging: true
    }, options)
    this.fabricJS = new fabric.Canvas(canvas);
    this.fabricJS.hoverCursor = 'pointer';
    this.fabricJS.backgroundColor = "#f6f6f6";
    this.fabricJS.selection = false;
    if (this.options.zoom)
        this.zoom_canvas = new add_zoom_canvas(this.fabricJS);
    if (this.options.dragging)
    this.dragging = new add_dragging(this.fabricJS);
    this.sourceImage = null;
    this.fabricJS.set({
        targetFindTolerance: 5,
        objectCaching: false,
    });
    this.add_plane_drawing = () => {
        this.planeDrawingTool = new planeDrawingTool(this.fabricJS);
        if (this.zoom_canvas)
            this.zoom_canvas.setCallback(this.planeDrawingTool.onUpdateScale);
    }

    this.addAdditionalElementsTool = () => {
        this.additionalElementsTool = new additionalElementsTool(this.fabricJS);
        if (this.zoom_canvas)
            this.zoom_canvas.setCallback(this.additionalElementsTool.onUpdateScale);
    }

    this.addPlatbandDrawingTool = () => {
        this.platbandDrawingTool = new platbandDrawingTool(this.fabricJS);
        if (this.zoom_canvas)
            this.zoom_canvas.setCallback(this.platbandDrawingTool.onUpdateScale);
    }

    this.showPlanes = async (options = {
        withTexture: false,
        scale: 1
    }) => {
        options.sourceImage = this.sourceImage;
        this.planeShower = await new planeTool(this.fabricJS, options);
    }

    this.addPlaneGroupingTool = async (options = {
        withTexture: false,
        scale: 1
    }) => {
        options.sourceImage = this.sourceImage;
        this.planeGroupingTool = await new planeGroupingTool(this.fabricJS, options);
    }

    this.showPlanesForTools = (excludePlaneID) => {
        const planeList = store.getters["active/ALL_PLANES_FROM_PHOTO"];
        const activePlaneID = store.state.route.params.planeID;
        let polygonArray = [];
        for (let planeID in planeList) {
            if (planeID == excludePlaneID)
                continue
            if (!planeList[planeID].isComplete)
                continue
            planeID = parseInt(planeID);
            let pointList;

            if (planeList[planeID].type === "additional") {
                if (planeList[activePlaneID].type === "additional")
                    pointList = getAdditionalPolygonPoints(planeList[planeID], 1);
                else
                    continue
            } else {
                pointList = planeList[planeID].points;
            }



            let polygon = planePolygonForTools(
                pointList,
                planeList[planeID].type,
                1,
                planeID,
                false
            );
            polygonArray.push(polygon);
            this.fabricJS.add(polygon);

            bus.$on("switchVisibilityBackgroundPlanes", (flag)=>{
                polygonArray.forEach((polygon)=>{
                    polygon.set({
                        opacity: flag?store.state.projectConfiguration.backgroundPlanesOpacity:0,
                    });
                })
                this.fabricJS.requestRenderAll();
            });
        }
    }

    this.sortObjectsByZindex = () => {
        sortObjectsByZindex(this.fabricJS);
    }


    this.updateCanvaSize = (size) => {
        this.fabricJS.setWidth(size.width);
        this.fabricJS.setHeight(size.height);
    }


    this.addSourceImage = (url,scaleImg) => {
        this.sourceImage = addImg(url).then((obj) => {
                // this.sourceImage = obj;
                this.fabricJS.add(obj);
                obj.set({
                    zIndex: 1,
                    hoverCursor: 'default'
                })
                if (scaleImg)
                    obj.scale(scaleImg)
                obj.sendToBack();

                return obj;
            }
        )
        return this.sourceImage
    }

    this.setViewport = (sourceImg, scaleImg) => {
        if (!router.currentRoute.query.view && sourceImg) {
            let scale = getScale(sourceImg, this.fabricJS);
            let center = sourceImg.getCenterPoint();
            let viewScale = 1;
            if (scaleImg)
                viewScale = scale/scaleImg;
            this.fabricJS.viewportTransform[0] = viewScale;
            this.fabricJS.viewportTransform[3] = viewScale;
            this.fabricJS.viewportTransform[4] = this.fabricJS.width / 2 - center.x * viewScale;
            this.fabricJS.viewportTransform[5] = this.fabricJS.height / 2 - center.y * viewScale;
            this.fabricJS.setViewportTransform(this.fabricJS.viewportTransform);
        } else if (router.currentRoute.query.view) {
            this.fabricJS.setViewportTransform(JSON.parse(router.currentRoute.query.view));
        }
        if (this.zoom_canvas)
            this.zoom_canvas.updateZoom();
    };

    this.addhomography = () => {
        new homography(this.fabricJS);
    }

    this.addSetPerspective = () => {
        this.setPerspective = new SetPerspectiveTool(this.fabricJS);
        if (this.zoom_canvas)
            this.zoom_canvas.setCallback(this.setPerspective.onUpdateScale);
    }

    this.addSetScale = () => {
        this.setScale = new SetScaleTool(this.fabricJS);
        if (this.zoom_canvas)
            this.zoom_canvas.setCallback(this.setScale.onUpdateScale);
    }

    this.setQuality = (quality) => {
        this.fabricJS.contextContainer.imageSmoothingQuality = quality; // "low", "med", "high"
    }

    this.destroy = () => {
        bus.$off("turnOffBackgroundPlanes");
        bus.$off("turnOnBackgroundPlanes");

        const toolsForDestroy = [
            this.planeGroupingTool,
            this.planeDrawingTool,
            this.setPerspective,
            this.setScale,
            this.additionalElementsTool,
            this.planeShower,
            this.platbandDrawingTool,
        ]

        toolsForDestroy.forEach((tool)=>{
            if (tool)
                tool.destroy();
        })

        this.fabricJS.dispose();
    }


    return this

}

export {fabricEditor}
